import {
  consuminginitiateconfig,
  getByDcUuid,
  } from '@/services/internal/facility/config/ConsumingInitiateConfig';

  export default {
    namespace: 'consumingInitiateConfig',
  
    state: {
      data: {
        consumingInitiateType:'LOGISTICS_ERP'
      },
    },
  
    effects: {
     *getByDcUuid({payload,callback},{call,put}){
        const response =yield call(getByDcUuid);
        yield put({
          type:'save',
          payload:response.success?response.data:{}
        })
        if(callback) callback(response)
     },
     *consuminginitiateconfig({payload,callback},{call,put}){
      const response =yield call(consuminginitiateconfig,payload);
      if(callback) callback(response)
     }
    },
  
    reducers: {
      save(state, action) {
        return {
          ...state,
          data: action.payload,
        };
      },
    }
  }
